function bannerMousedown(e, id,  id2) {
  e.preventDefault();
  if(!('ontouchend' in document)){
    const simpleBannerWrapperElem = document.getElementById(id);
    const simpleBannerElem = document.getElementById(id2);
    simpleBannerWrapperElem.dataset.mouse = 'down';
    simpleBannerWrapperElem.dataset.clientx = e.clientX;
    simpleBannerWrapperElem.dataset.scrollx = simpleBannerElem.scrollLeft;
  }
}
function bannerMouseup(e, id) {
  if(!('ontouchend' in document)){
    const simpleBannerWrapperElem = document.getElementById(id);
    simpleBannerWrapperElem.dataset.mouse = 'up';
    simpleBannerWrapperElem.dataset.mousemove = 'false';
  }
}
function bannerMousemove(e, id, id2) {
  if(!('ontouchend' in document)){
    const simpleBannerWrapperElem = document.getElementById(id);
    const simpleBannerElem = document.getElementById(id2);
    if(simpleBannerWrapperElem.dataset.mouse == "down") {
      let scrollx = simpleBannerWrapperElem.dataset.scrollx;
      if(!scrollx) {
        scrollx = 0;
      } else {
        scrollx = parseInt(scrollx)
      }
      let scrollLeftBefore = simpleBannerElem.scrollLeft;
      simpleBannerElem.scrollLeft = simpleBannerWrapperElem.dataset.clientx - e.clientX + scrollx;
      if (scrollLeftBefore != simpleBannerElem.scrollLeft) {
        simpleBannerWrapperElem.dataset.mousemove = 'true';
      }
    }
  }
}
